import styled from 'styled-components';
import BackgroundLight from '../../../../assets/images/background-tallkme-ligth.svg'
import BackgroundDark from '../../../../assets/images/background-tallkme-dark.svg'


export const Container = styled.div`
    position: absolute;
    display: ${props => props.open ? 'flex' : 'none'};
    width: 400px;
    height: 500px;
    box-shadow: 0 0 1px #A7A7A7;
    right: 20px;
    bottom: 20px;
    z-index: 9999;
`;

export const Content = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 342px;
    height: 500px;
    left: 58px;
    top: 0px;

    background: url(${BackgroundLight});
`;

export const Widget = styled.img`
    position: absolute;
    display: ${props => props.open ? 'flex' : 'none'};
    width: 44.55px;
    height: 45px;
    right: 20px;
    bottom: 10px;
    cursor: pointer;
    z-index: 9999;
`;
